import { Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const SubscriberCounter = () => {
  const { t } = useTranslation();
  
  return (
    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-newsletter-primary/10 border border-newsletter-primary/20">
      <Users className="w-4 h-4 text-newsletter-primary" />
      <span className="text-sm font-medium text-newsletter-primary">
        {t('subscriberCounter.text')}
      </span>
    </div>
  );
};